// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602261303/js/" + chunkId + "." + {"44":"9e6c4cf2","225":"5dda7d6a","481":"a725f47e","486":"4a551d72","770":"f2dfb3e2"}[chunkId] + ".0.9488292929516773.chunk.js";
};